<template>
    <div class="pt-3" id="filter-reserva">
        <div class="modal-body">
            <ModalBodySectionComponent
                    eyebrow="Filtros"
                    title="Filtros de reservas"
                    subtitle="Informe um ou mais criterios para refinar a busca."
                    icon="icon-filter_list">
                <template #actions>
                    <div class="reserve-filter-allotment-badge">
                        <span class="reserve-filter-allotment-badge__icon icon-grid"></span>
                        <span class="reserve-filter-allotment-badge__content">
                            <span class="reserve-filter-allotment-badge__label">Loteamento</span>
                            <strong>{{ allotmentLabel }}</strong>
                        </span>
                    </div>
                </template>

            <div class="row gutters mt-2">
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="form-group">
                        <label>{{ t('RESERVE.REALTOR') }}: </label>
                        <Select2 :settings="{ width: '100%', placeholder: 'Selecione um Corretor'}" :options="realtors"
                                 v-model="filter.realtorId" :disabled="allotmentid === null"/>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="form-group">
                        <label>{{ t('RESERVE.STATUS') }}: </label>
                        <Select2 :settings="{ width: '100%', placeholder: 'Selecione um Status'}" :options="status"
                                 v-model="filter.reserveStatusType" :disabled="allotmentid === null"/>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-3 col-12">
                    <div class="form-group">
                        <label>{{ t('RESERVE.TYPE') }}: </label>
                        <Select2 :settings="{ width: '100%', placeholder: 'Selecione um Tipo'}"
                                 :options="[{id:'Nenhum', text: 'Nenhum'},...reserveTypes]"
                                 v-model="filter.reserveType" :disabled="allotmentid === null"/>
                    </div>
                </div>
                <div class="col-xl-6 col-lg-6 col-md-6 col-sm-12 col-12">
                    <div class="form-group">
                        <label>{{ t('RESERVE.CLIENT') }}: </label>
                        <Select2 :settings="ajaxPerson" placeholder="Selecione"
                                 @select="selectClient"
                                 v-model="filter.clientId" :disabled="allotmentid === null"/>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                    <div class="form-group">
                        <label>{{ t('PROPERTIES.BLOCK') }}: </label>
                        <Select2 :settings="{ width: '100%', placeholder: 'Selecione uma Quadra'}" :options="blocks"
                                 v-model="filter.block" @select="searchBlock($event)" :disabled="allotmentid === null"/>
                    </div>
                </div>
                <div class="col-xl-3 col-lg-3 col-md-3 col-sm-12 col-12">
                    <div class="form-group">
                        <label>{{ t('PROPERTIES.NAME') }}: </label>
                        <Select2 id="lots" :settings="{ width: '100%', placeholder: 'Selecione um lote'}"
                                 :options="lots"
                                 v-model="filter.lots" @select="searchLots($event)"
                                 :disabled="allotmentid === null"/>
                    </div>
                </div>
            </div>
            </ModalBodySectionComponent>
        </div>
        <div class="modal-footer right">
            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal" @click="$emit('close')">
                {{ t('ACTIONS.CLOSE') }}
            </button>
            <button type="button" class="btn btn-secondary mr-1" data-dismiss="modal" @click="$emit('closeClear')">
                Limpar
            </button>
            <button type="button" class="btn btn-primary mr-1" @click="search()">{{ t('ACTIONS.FILTER') }}</button>
        </div>
    </div>
</template>


<script>

import {useI18n} from "vue-i18n";
import Reserve from "@/services/Reserves";
import Select2 from 'vue3-select2-component';
import Validate from '@/components/validate.vue';
import {mapState} from "vuex";
import User from '@/services/user';
import Lots from '@/services/Lots';
import ReserveStatus from "@/services/ReserveStatus";
import ReserveTypes from '../../services/ReserveTypes';
import {useToast} from 'vue-toastification';
import ModalBodySectionComponent from '../../components/layouts/ModalBodySectionComponent';

export default {
    name: 'filterReserve',
    mixins: [Validate],
    props: ['blocksIndex', 'statusIndex', 'clientsIndex', 'realtorsIndex', 'allotmentId', 'lotsIndex', 'perPageIndex'],
    components: {
        Select2,
        ModalBodySectionComponent,
    },
    emits:['search', 'close', 'closeClear'],
    setup() {
        const toast = useToast();
        const {t} = useI18n();
        return {t, toast};
    },

    data() {
        return {
            blocks: null,
            allotmentid: null,
            status: null,
            lots: [],
            blockId: null,
            itemsReserve: null,
            realtors: [{}],
            clients: [],
            reserveTypes: [],
            filterBlock: null,
            filter: {
                lots: null,
                block: null,
                clientId: null,
                realtorId: null,
                reserveStatusType: null,
            },
            ajaxPerson: {
                width: '100%',
                language: {
                    inputTooShort: function () {
                        return "Por favor, insira ao menos 1 caracteres para pesquisar.";
                    },
                    noResults: function () {
                        return "Nenhum resultado encontrado!";
                    }
                },
                minimumInputLength: 1,
                ajax: {
                    url: `${process.env.VUE_APP_BACK_END}/api/v1/clientes/list`,
                    dataType: "json",
                    headers: {
                        'authorization': `Bearer ${localStorage.getItem('access_token')}`,
                        'company-id': localStorage.getItem('companyId'),
                    },
                    data: params => {
                        return {
                            term: params.term,
                        };
                    },
                    processResults: function (data) {
                        if (!(data.validations)) {
                            data = data.map((i) => ({id: i.id, text: i.name}));
                            data.unshift({id: 0, text: "Nenhum"});
                            return {
                                results: data
                            };
                        } else {
                            return {results: {id: 0, text: "Nenhum"}};
                        }
                    },
                    cache: true
                },
                initSelection: function (element, callback) {
                    callback({id: 1, text: 'initSelection test'});
                },
            },
        }
    },
    computed: {
        ...mapState({
            allotments: 'allotments',
        }),
        allotmentLabel() {
            const allotment = this.allotments?.find(item => item.id == this.allotmentid);

            return allotment?.text || allotment?.name || this.allotmentid || '-';
        },
    },
    mounted() {
        this.allotmentid = this.allotmentId;
        if(this.allotmentid) this.changeAllotment();
    },
    watch: {
        allotmentId: function () {
            this.allotmentid = this.allotmentId;
            this.changeAllotment();
        },
        blocksIndex: function () {
            this.blocks = [{id: 0, text: 'Nenhum'}, ...this.blocksIndex];
        },
        lotsIndex: function () {
            this.lots = this.lotsIndex;
            this.lots.unshift('Nenhum');
        },
        statusIndex: function () {
            this.status = this.statusIndex;
        },

        clientsIndex: function () {
            this.clients = this.clientsIndex;
        },
        realtorsIndex: function () {
            this.realtors = this.realtorsIndex;
        }
    },

    methods: {
        selectClient({id, text}) {
            if(text === 'Nenhum'){
                this.filter.clientId = null;
                this.filter.clientName = null;
            }else {
                this.filter.clientId = id;
                this.filter.clientName = text;
            }
        },
        searchBlock({text, id}) {
            this.blockId = id;
            this.filterblock = text == 'Nenhum' ? null : text;
        },
        searchLots({text}) {
            this.filter.lots = text == 'Nenhum' ? null : text;
        },
        async changeAllotment() {
            this.$store.commit('changeLoading', true);
            this.filter = {
                lots: null,
                block: null,
                clientId: null,
                realtorId: null,
                reserveStatusType: null,
            };
            this.clients = [];
            this.realtors = [];
            this.lots = [];
            this.blocks = null;
            await this.indexRealtor(this.allotmentid);
            await this.getLots(this.allotmentid);
            await this.indexBlocks(this.allotmentid);
            await this.indexStatus(this.allotmentid);
            this.$store.commit('changeLoading', false);
        },
        getRerservesType(allotment_id) {
            ReserveTypes.list(allotment_id).then(resp => {
                this.reserveTypes = resp.data;
            })
        },
        async indexBlocks(allotment_id) {
            await Lots.blocksList(allotment_id).then(async resp => {
                if (!resp.data?.validations) {
                    resp.data = resp.data.map(i => {
                        return {
                            id: i.text,
                            text: i.text,
                        }
                    })
                    this.blocks = [{id: 0, text: 'Nenhum'}, ...resp.data];
                }
            }).catch(error => {
                this.errorMsg(error);
            });
        },

        async startReserve(allotment_id) {
            await this.indexReserve(allotment_id);
        },

        async indexReserve(allotment_id = this.allotmentId, page = 1) {
            this.$store.commit('changeLoading', true);
            await Reserve.index(this.filter, allotment_id, page).then(resp => {
                this.itemsReserve = resp.data;
                this.startAfterReseve(resp.data?.data);
            }).catch(error => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(error);
            });
        },

        async startAfterReseve(reserves) {
            if (reserves) {
                await reserves.forEach((reserve,) => {
                    this.indexClients(reserve);
                });
                this.$store.commit('changeLoading', false);
            } else {
                this.$store.commit('changeLoading', false);
            }
        },

        indexClients(reseves) {
            reseves.reserves_clients.forEach(reserveClients => {
                if (reserveClients.clients) {
                    if (!this.clients.find(client => client.id == reserveClients.clients?.id)) {
                        this.clients.push({id: reserveClients.clients?.id, text: reserveClients.clients?.name});
                    }
                }
            });

            if (!this.clients.find(c => c.id == 0)) {
                this.clients.unshift({id: 0, text: this.t('GENERAL.NONE')});
            }
        },

        async indexStatus() {
            await ReserveStatus.list().then(resp => {
                if (!resp.data?.validations) {
                    this.status = resp.data;
                    this.status.unshift({id: 99, text: this.t('GENERAL.NONE')});
                }
                this.$store.commit('changeLoading', false);
            }).catch(error => {
                this.errorMsg(error);
                this.$store.commit('changeLoading', false);
            });
        },

        async getLots() {
            await Lots.getLotsByAllotment(this.allotmentid).then(resp => {
                this.lots = [{id: 0, text: 'Nenhum'}, ...resp.data];
            })
        },

        async indexRealtor(allotment_id) {
            await User.listRealtor(allotment_id, true).then(resp => {
                if (!resp.data.validations) {
                    this.realtors = [];
                    this.realtors = resp.data.filter(item => {
                        if (typeof item === 'object' && item !== null) {
                            return {
                                id: item.id,
                                text: item.text,
                            }
                        }
                    });
                    this.realtors.unshift({id: 0, text: this.t('GENERAL.NONE')});
                } else this.realtors = [{id: 0, text: 'Nenhum'}];
            }).catch(error => {
                this.errorMsg(error);
            });
        },

        verifyFilterNotEmpty()
        {
            if (!this.filter.block && !this.filter.clientId && !this.filter.lots && !this.filter.realtorId &&
            !this.filter.reserveStatusType && !this.allotmentid && !this.filter.reserveType){
                this.toast.error('Necessário Selecionar  um Filtro')
                return true;
            }
            return  false
        },

        search() {
            if (this.verifyFilterNotEmpty()){
                return;
            }
            this.$store.commit('changeLoading', true);
            this.checkFilterNone();
            Reserve.index(this.filter, this.allotmentid, 1, this.perPageIndex).then(resp => {
                this.$emit('search', resp, {...this.filter}, this.allotmentid);
                if (this.blockId != 0) {
                    this.filter.block = this.blockId;
                }
                document.getElementById('closeX').click();
                this.$store.commit('changeLoading', false);
            }).catch(error => {
                this.$store.commit('changeLoading', false);
                this.errorMsg(error);
            });
        },

        checkFilterNone() {
            this.filter.block = this.filter.block == 0 ? null : this.filterblock;
            this.filter.clientId = this.filter.clientId == 0 ? null : this.filter.clientId;
            this.filter.realtorId = this.filter.realtorId == 0 ? null : this.filter.realtorId;
            this.filter.reserveStatusType = this.filter.reserveStatusType == 99 ? null : this.filter.reserveStatusType;
            this.filter.reserveType = this.filter.reserveType === 'Nenhum' ? null : this.filter.reserveType;
        },
    }
}
</script>

<style scoped>
.reserve-filter-allotment-badge {
    align-items: center;
    background: #f5faf8;
    border: 1px solid #dcebe7;
    box-shadow: none;
    color: #173b34;
    display: inline-flex;
    gap: 0.58rem;
    max-width: 360px;
    min-height: 42px;
    padding: 0.42rem 0.72rem 0.42rem 0.5rem;
}

.reserve-filter-allotment-badge__icon {
    align-items: center;
    background: #e2f2ed;
    box-shadow: none;
    color: #0e5e4e;
    display: inline-flex;
    flex: 0 0 30px;
    height: 30px;
    justify-content: center;
    width: 30px;
}

.reserve-filter-allotment-badge__icon::before {
    color: #0e5e4e;
}

.reserve-filter-allotment-badge__content {
    line-height: 1.1;
    min-width: 0;
}

.reserve-filter-allotment-badge__label {
    color: #0e5e4e;
    display: block;
    font-size: 0.62rem;
    font-weight: 700;
    letter-spacing: 0.1em;
    margin-bottom: 0.18rem;
    text-transform: uppercase;
}

.reserve-filter-allotment-badge strong {
    display: block;
    font-size: 0.84rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

:global(html.dark-theme .reserve-filter-allotment-badge) {
    background: rgba(20, 184, 166, 0.08) !important;
    border-color: rgba(94, 234, 212, 0.14) !important;
    box-shadow: none !important;
    color: var(--dark-text) !important;
}

:global(html.dark-theme .reserve-filter-allotment-badge__icon) {
    background: rgba(20, 184, 166, 0.12) !important;
    box-shadow: none !important;
    color: var(--dark-primary) !important;
}

:global(html.dark-theme .reserve-filter-allotment-badge__label) {
    color: var(--dark-text-muted) !important;
}

@media (max-width: 575px) {
    .reserve-filter-allotment-badge {
        max-width: 100%;
        width: 100%;
    }
}
</style>
